export default {

    // Business

    SET_BUSINESS_DATEGROUP_REPORTS: (state, reports) => {
        state.business.dateGroup.reports = reports
    },

    SET_BUSINESS_DATEGROUP_SUM: (state, sum) => {
        state.business.dateGroup.sum = sum
    },

    SET_BUSINESS_DATEGROUP_LOAD: (state, isLoaded) => {
        state.business.dateGroup.isLoaded = isLoaded
    },

    SET_BUSINESS_DATEGROUP_FILTERS: (state, filters) => {
        state.business.dateGroup.filters = filters
    },

    SET_BUSINESS_DATEGROUP_PAGINATION: (state, pagination) => {
        state.business.dateGroup.pagination = pagination
    },

    RESET_BUSINESS_DATEGROUP_REPORTS: (state) => {
        state.business.dateGroup.filters = {
            fromDate: null,
            toDate: null
        }
    },

    // LEADER

    SET_LEADER_BUSINESSGROUP_REPORTS: (state, reports) => {
        state.leader.businessGroup.reports = reports
    },

    SET_LEADER_BUSINESSGROUP_SUM: (state, sum) => {
        state.leader.businessGroup.sum = sum
    },

    SET_LEADER_BUSINESSGROUP_LOAD: (state, isLoaded) => {
        state.leader.businessGroup.isLoaded = isLoaded
    },

    SET_LEADER_BUSINESSGROUP_FILTERS: (state, filters) => {
        state.leader.businessGroup.filters = filters
    },

    SET_LEADER_BUSINESSGROUP_PAGINATION: (state, pagination) => {
        state.leader.businessGroup.pagination = pagination
    },

    RESET_LEADER_BUSINESSGROUP_REPORTS: (state) => {
        state.leader.businessGroup.filters = {
            fromDate: null,
            toDate: null
        }
    },

    // Admin leader group

    SET_ADMIN_LEADERGROUP_REPORTS: (state, reports) => {
        state.admin.leaderGroup.reports = reports
    },

    SET_ADMIN_LEADERGROUP_SUM: (state, sum) => {
        state.admin.leaderGroup.sum = sum
    },

    SET_ADMIN_LEADERGROUP_LOAD: (state, isLoaded) => {
        state.admin.leaderGroup.isLoaded = isLoaded
    },

    SET_ADMIN_LEADERGROUP_FILTERS: (state, filters) => {
        state.admin.leaderGroup.filters = filters
    },

    SET_ADMIN_LEADERGROUP_PAGINATION: (state, pagination) => {
        state.admin.leaderGroup.pagination = pagination
    },

    RESET_ADMIN_LEADERGROUP_REPORTS: (state) => {
        state.admin.leaderGroup.filters = {
            fromDate: null,
            toDate: null
        }
    },

    // Admin business group

    SET_ADMIN_BUSINESSGROUP_REPORTS: (state, reports) => {
        state.admin.businessGroup.reports = reports
    },

    SET_ADMIN_BUSINESSGROUP_SUM: (state, sum) => {
        state.admin.businessGroup.sum = sum
    },

    SET_ADMIN_BUSINESSGROUP_LOAD: (state, isLoaded) => {
        state.admin.businessGroup.isLoaded = isLoaded
    },

    SET_ADMIN_BUSINESSGROUP_FILTER_LEADER: (state, leader) => {
        state.admin.businessGroup.filters.leader = leader
    },

    SET_ADMIN_BUSINESSGROUP_FILTERS: (state, filters) => {
        state.admin.businessGroup.filters = filters
    },

    SET_ADMIN_BUSINESSGROUP_PAGINATION: (state, pagination) => {
        state.admin.businessGroup.pagination = pagination
    },

    RESET_ADMIN_BUSINESSGROUP_REPORTS: (state) => {
        state.admin.businessGroup.filters = {
            fromDate: null,
            toDate: null,
            leaderId: null
        }
    },

    // Admin day group

    SET_ADMIN_DAYGROUP_REPORTS: (state, reports) => {
        state.admin.dayGroup.reports = reports
    },

    SET_ADMIN_DAYGROUP_SUM: (state, sum) => {
        state.admin.dayGroup.sum = sum
    },

    SET_ADMIN_DAYGROUP_LOAD: (state, isLoaded) => {
        state.admin.dayGroup.isLoaded = isLoaded
    },

    SET_ADMIN_DAYGROUP_FILTERS: (state, filters) => {
        state.admin.dayGroup.filters = filters
    },

    SET_ADMIN_DAYGROUP_PAGINATION: (state, pagination) => {
        state.admin.dayGroup.pagination = pagination
    },

    RESET_ADMIN_DAYGROUP_REPORTS: (state) => {
        state.admin.dayGroup.filters = {
            fromDate: null,
            toDate: null
        }
    }
}
